export const RESET_PASS_REQUESTING = 'RESET_PASS_REQUESTING';
export const RESET_PASS_SUCCESS = 'RESET_PASS_SUCCESS';
export const RESET_PASS_ERROR = 'RESET_PASS_ERROR';
